import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './AnimalNotes.css';
import { Fetch } from '../utils/Utils.js';
import { formatDate as formatDateLocale } from '../../utils/dateFormat.js';

// AnimalNotes is the shared notes UI for any animal, by tag — backed by the
// dedicated animals.notes collection (internal/animals/notes), not an
// embedded field on whatever lot/herd row happens to be showing it. Used by
// both Herd Animals and Reproduction Animals; data only needs a .tag and a
// .notes array (the caller's list endpoint should already join notes in —
// see HandleGetHerdAnimals/HandleGetReproductionAnimals).
export const AnimalNotes = ({ data, onNoteAdded }) => {
  const { t } = useTranslation();
  const [newNote, setNewNote] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const notes = data.notes || [];

  const handleAddNote = () => {
    if (!newNote.trim()) return;

    setIsSubmitting(true);

    // created_by/created_at are derived server-side from the authenticated
    // caller — not client-supplied.
    Fetch(`/api/animals/${data.tag}/notes`, 'POST',
      JSON.stringify({ note: newNote.trim() }),
      () => {
        setNewNote('');
        setIsSubmitting(false);
        if (onNoteAdded) {
          onNoteAdded();
        }
      },
      () => {
        setIsSubmitting(false);
        console.error('Error adding note');
      }
    );
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return formatDateLocale(date) + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="animal-notes">
      <div className="notes-header">
        <span className="notes-icon">&#128221;</span>
        <h4>{t('notes')}</h4>
      </div>

      <div className="notes-list">
        {notes.length === 0 && (
          <p className="no-notes">{t('no_notes')}</p>
        )}
        {notes.map((note, index) => (
          <div key={index} className="note-item">
            <div className="note-meta">
              <span className="note-author">{note.created_by}</span>
              <span className="note-date">{formatDate(note.created_at)}</span>
            </div>
            <div className="note-text">{note.note}</div>
          </div>
        ))}
      </div>

      <div className="add-note-section">
        <textarea
          className="note-input"
          placeholder={t('add_note_placeholder')}
          value={newNote}
          onChange={(e) => setNewNote(e.target.value)}
          rows={2}
        />
        <button
          className="add-note-button"
          onClick={handleAddNote}
          disabled={isSubmitting || !newNote.trim()}
        >
          {isSubmitting ? t('adding') : t('add_note')}
        </button>
      </div>
    </div>
  );
};

export default AnimalNotes;
